// src/sections/services/DesktopServicesRight.jsx
import "./DesktopServicesRight.css";
import { useLang } from "../../../../i18n/LangContext";

export default function DesktopServicesRight({
  id = "services",
  leftSrc,            // <-- PNG път (задължителен за лявото)
  leftAlt = "Services art",
  onAdvertise,
  onMonetize,
}) {
  const { t } = useLang();

  return (
    <section id={id} className="srv-root srv-desktop" aria-label="Our services">
      <div className="srv-wrap">
        {/* TOP CENTER HEAD */}
        <div className="srv-head">
          <p className="srv-eyebrow">{t.services.eyebrow}</p>
          <h2 className="srv-title">
            {t.services.titleLine1}<br />{t.services.titleLine2}
          </h2>
        </div>
        {/* LEFT: PNG image */}
        <div className="srv-left">
          {leftSrc ? <img src={leftSrc} alt={leftAlt} className="srv-left-img" /> : null}
        </div>

        {/* RIGHT: content */}
        <div className="srv-right">
          <div className="srv-cards">
            <article className="srv-card">
              <header className="srv-card-head">
                <span className="dot" />
                <div>
                  <h3 className="srv-card-title">{t.services.advertise.title}</h3>
                  <div className="srv-card-kicker">{t.services.advertise.kicker}</div>
                </div>
              </header>
              <p className="srv-card-desc">{t.services.advertise.desc}</p>
              <button className="srv-cta">
                <span className="srv-cta-inner">{t.services.advertise.cta.toUpperCase()}</span>
              </button>
            </article>

            <article className="srv-card">
              <header className="srv-card-head">
                <span className="dot" />
                <div>
                  <h3 className="srv-card-title">{t.services.monetize.title}</h3>
                  <div className="srv-card-kicker">{t.services.monetize.kicker}</div>
                </div>
              </header>
              <p className="srv-card-desc">{t.services.monetize.desc}</p>
              <button className="srv-cta">
                <span className="srv-cta-inner">{t.services.advertise.cta.toUpperCase()}</span>
              </button>
            </article>
          </div>
        </div>
      </div>
    </section>
  );
}
